import { useRef, useState, useLayoutEffect, useEffect } from "react"
import { useScroll } from "framer-motion"
import styled from "@emotion/styled"

import ExploCard from "components/cards/ExploCard"

import { useValue } from "./context"
import Arrows from "./Arrows"

const Strip = styled.ul`
  display: flex;
  gap: var(--grid-gap);

  grid-row: 1;
  grid-column: 1;

  overflow-x: auto;
  overflow-y: hidden;

  padding-inline-start: var(--outer-margin);

  scroll-snap-type: x mandatory;

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  // to prevent cards focus outline to be cut :
  padding-block-start: 10px;
  margin-block-start: -10px;
  padding-block-end: 10px;
  margin-block-end: -10px;
  //////////////////////////////////////////////
`

const ListElement = styled.li`
  scroll-snap-align: center;

  flex: 0 0 calc(var(--grid-col-unit) * 5 + var(--grid-gap) * 4);

  &:first-of-type {
    html:not([dir="rtl"]) & {
      scroll-snap-align: start;
    }
    scroll-margin-left: var(--outer-margin);
  }
  &:last-of-type {
    scroll-snap-align: end;
    scroll-margin-right: var(--outer-margin);
    padding-inline-end: var(--outer-margin);
  }
  figcaption {
    span,
    h3 {
      html.prefers-contrast & {
        color: black !important;
        position: relative;
      }
    }

    html.prefers-contrast & {
      position: relative;

      ::before {
        background: white;
        content: "";
        height: calc(100% + 30px);
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% + 20px);
        z-index: 0;
      }
    }
  }
`

export default function EditoRoller({ cards }) {
  const ref = useRef()

  const { max, unit, isTouchDevice, assetCenter } = useValue()

  const { scrollX } = useScroll({ container: ref })

  const [showArrows, setShowArrows] = useState(true)

  function updateUnit() {
    max.set(ref.current.scrollWidth - ref.current.clientWidth - unit.get() / 4)
    setShowArrows(max.get() > 0)
  }

  function metrics() {
    unit.set(ref.current.children[0].offsetWidth)
    const image = ref.current.children[0].getElementsByTagName("img")[0]
    const ce = (unit.get() * (image.height / image.width)) / 2
    assetCenter.set(ce)
  }

  const onWchange = () => updateUnit()
  useEffect(() => unit.onChange(onWchange))

  useLayoutEffect(() => {
    metrics()
    updateUnit()
  }, [])

  useLayoutEffect(() => {
    const r = ref.current

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.contentBoxSize) {
          metrics()
        }
      }
    })

    resizeObserver.observe(r)

    return () => resizeObserver.unobserve(r)
  }, [])

  return (
    <>
      <Strip ref={ref}>
        {cards.map(c => (
          <ListElement key={c._metadata.uid}>
            <ExploCard {...c} url={c.href} />
          </ListElement>
        ))}
      </Strip>
      {showArrows && !isTouchDevice ? <Arrows ref={ref} scrollX={scrollX} /> : null}
    </>
  )
}
